import Select from 'react-select';
import React, {useState} from 'react';

const ReactSelect = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  let errorMsg = '';
  let isError = false;

  if (props.error && props.error.length > 0) {
    errorMsg = props.error;
    isError = true;
  }

  if (props.gaEvent && isOpen) {
    props.gaEvent();
  }

  const dot = (color = 'var(--theme-primary, #9631ff)') => ({
    alignItems: 'center',
    display: 'flex',
    ':after': {
      content: props.required ? '" * "' : '" "',
      background: 'transparent',
      marginRight: 5,
      zIndex: -1,
      color: color,
    },
  });

  return (
    <div className='react-select'>
      <Select
        ref={props.ref}
        blurInputOnSelect={true}
        isSearchable={props.preventKeyboard}
        onMenuOpen={() => setIsOpen(true)}
        onMenuClose={() => setIsOpen(false)}
        isDisabled={props.disabled ?? false}
        styles={{
          indicatorSeparator: () => {},
          control: (base, state) => ({
            ...base,
            marginBottom: isError ? '0px' : '10px',
            border: props.border ? props.border : state.isFocused || isError ? '1px solid var(--theme-primary, #9631ff)' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '1px solid var(--theme-primary, #9631ff)' : '1px solid #ced4da',
            '&:hover': {
              border: props.focusedBorder ? props.focusedBorder : state.isFocused ? '1px solid var(--theme-primary, #9631ff)' : '1px solid #ced4da',
            },
          }),
          option: (styles, state) => ({
            ...styles,
            color: '#000',
            backgroundColor: state.isFocused ? '#e7e9eb' : 'white',
          }),
          dropdownIndicator: (defaultStyles) => ({
            ...defaultStyles,
            color: 'var(--theme-primary, #9631ff)',
            transition: 'all .2s ease',
            transform: isOpen ? 'rotate(180deg)' : null,
          }),
          placeholder: (styles) => ({...styles, ...dot(), color: props.placeholderColor ?? null}),
        }}
        classNamePrefix='react-select'
        className='react-select-container'
        options={props.options}
        placeholder={props.placeholder}
        {...props}
      />
      {props.error && props.error.length > 0}
      <div className='error'>{props.error}</div>
    </div>
  );
};

export default ReactSelect;
